import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-custom-btn',
  templateUrl: './custom-btn.component.html',
  styleUrls: ['./custom-btn.component.scss'],
})
export class CustomBtnComponent {
  @Input() text: string = '';
  @Input() color: string = '';
  @Input() type: string = '';
  @Output() handleClick: EventEmitter<any> = new EventEmitter();
  constructor() {}

  onClick() {
    this.handleClick.emit();
  }
}

